// src/components/SubscriptionModal.js

import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import {
  Modal,
  Box,
  Typography,
  Button,
  Divider,
} from '@mui/material';
import { styled } from '@mui/system';

const StyledModal = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '16px',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4),
  maxWidth: '500px',
  width: '90%',
}));

const SubscriptionModal = ({ open, handleClose, subscriptionPlan }) => {
  const { login } = useContext(AuthContext);

  const handleLogin = () => {
    // Save the selected plan in localStorage to retrieve after OAuth2
    localStorage.setItem('selectedPlan', JSON.stringify(subscriptionPlan));
    login('subscribe'); // Initiates OAuth2 flow with 'subscribe' state
  };

  return (
    <StyledModal
      open={open}
      onClose={handleClose}
      aria-labelledby="subscription-modal-title"
      aria-describedby="subscription-modal-description"
    >
      <ModalContent>
        <Typography id="subscription-modal-title" variant="h5" gutterBottom>
          Confirm Your Subscription
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography id="subscription-modal-description" variant="body1">
          You are about to purchase the <strong>{subscriptionPlan.title}</strong> plan for <strong>{subscriptionPlan.price}</strong>.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          This plan includes:
        </Typography>
        <ul>
          {subscriptionPlan.features.map((feature, index) => (
            <li key={index}>
              <Typography variant="body2">{feature}</Typography>
            </li>
          ))}
        </ul>
        <Divider sx={{ my: 2 }} />
        <Button variant="contained" color="primary" onClick={handleLogin} fullWidth>
          Login with Discord to Continue
        </Button>
      </ModalContent>
    </StyledModal>
  );
};

export default SubscriptionModal;

